export default {
    myPrivList: [],
    myAwards: [],
    UserMap : {}
}
